import React, { useRef, useState } from "react";
import styles from "./Suggestions.module.css";
import Button from "../components/Button";
import Forminput from "../components/forminput";
import { luckySubmitApi } from "../api";
import { useData } from "../contexts/DataContext";
import ButtonBack from "../components/ButtonBack";

const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
const phonePattern = /^0[0-9]+$/;

function Suggestions(props) {
  const refLoading = useRef(false);
  const { id, updateSuggestion } = useData();
  const [fullName, setFullname] = useState();
  const [email, setEmail] = useState();
  const [phone, setPhone] = useState();
  const [address, setAddress] = useState();
  const [send, setSend] = useState(false);
  const [errors, setErrors] = useState({});
  const [isAgreed, setIsAgreed] = useState(false);

  const submitData = async () => {
    let newErrors = {};

    if (refLoading.current) {
      return;
    }

    if (!fullName) {
      newErrors = { ...newErrors, name: "กรุณาระบุชื่อ - สกุล" };
    }

    if (!email) {
      newErrors = { ...newErrors, email: "กรุณาระบุอีเมลติดต่อ" };
    } else if (!emailPattern.test(email)) {
      newErrors = { ...newErrors, email: "อีเมลไม่ถูกต้อง" };
    }

    if (!phone) {
      newErrors = { ...newErrors, phone: "กรุณาระบุเบอร์โทรศัพท์ติดต่อ" };
    } else if (!phonePattern.test(phone)) {
      newErrors = { ...newErrors, phone: "เบอร์โทรศัพท์ไม่ถูกต้อง" };
    }

    if (!address) {
      newErrors = { ...newErrors, address: "กรุณาระบุที่อยู่" };
    }

    if (!isAgreed) {
      newErrors = { ...newErrors, isAgreed: "กรุณายอมรับนโยบายคุ้มครองข้อมูลส่วนบุคคล" };
    }

    setErrors(newErrors);
    if (Object.keys(newErrors).length) {
      return;
    }

    try {
      refLoading.current = true;
      await luckySubmitApi({
        guid: id,
        fullname: fullName,
        email,
        phone,
        address,
      });
      setSend(true);
      updateSuggestion(true);
    } catch (err) {
      alert("เกิดข้อผิดพลาดในการส่งข้อมูล");
    } finally {
      refLoading.current = false;
    }
  };

  return (
    <div>
      <div className={styles.header}>
        {!send && (
          <>
            <h1 className={styles.h1}>รับข่าวสารเพิ่มเติม</h1>
            <div className={styles.subheader1}>
              หากอยากรับข่าวสารวิธีพัฒนาทักษะทางสมองและข่าวสารเกี่ยวกับสุขภาพของ
              สสส.{" "}
            </div>
            <div className={styles.subheader2}>
              กรุณาให้ข้อมูลของคุณไว้ตามข้างล่างนี้{" "}
            </div>
          </>
        )}
        {send && (
          <>
            <div className={styles.subheader3}>
              ได้รับข้อมูลของคุณเรียบร้อยแล้ว
            </div>
            <Button onClick={() => props.restartGame()}>ทดสอบอีกครั้ง</Button>
            <Button onClick={() => props.navigatePrevPage()}>กลับไปดูผลลัพธ์</Button>
          </>
        )}
      </div>
      {!send && (
        <form className={styles.form}>
          <Forminput
            header="ชื่อ-นามสกุล"
            id="name"
            type="text"
            maxLength={250}
            value={fullName}
            onChange={(val) => setFullname(val)}
            error={errors["name"]}
          />
          <Forminput
            header="อีเมล"
            id="email"
            type="email"
            maxLength={250}
            value={email}
            onChange={(val) => setEmail(val)}
            error={errors["email"]}
          />
          <Forminput
            header="เบอร์โทร"
            id="phone"
            type="tel"
            maxLength={10}
            value={phone}
            onChange={(val) => setPhone(val)}
            error={errors["phone"]}
          />
          <div className={styles.addressText}>
            ข้อมูลที่คุณได้ทดสอบจะไม่ถูกจัดเก็บไว้เพื่อสิทธิความเป็นส่วนตัวแต่หากคุณอยากร่วมส่งข้อมูล
            เพื่อชิงรางวับกับกิจกรรมนี้กรุณาให้ที่อยู่ของการจัดส่งรางวัล
          </div>
          <Forminput
            header="ที่อยู่"
            id="address"
            type="address"
            maxLength={500}
            value={address}
            onChange={(val) => setAddress(val)}
            error={errors["address"]}
          />
          <div className={styles.error}>{errors["isAgreed"]}</div>
          <input
            type="checkbox"
            id="terms"
            checked={isAgreed}
            onChange={() => setIsAgreed(!isAgreed)} 
          />

          <label htmlFor="terms">
            ฉันได้อ่านและยอมรับ
            <a
              href="https://pdpa.thaihealth.or.th/content/policy"
              target="_blank"
              rel="noopener noreferrer"
              className={styles.subbodytext2}
            >
              นโยบายการคุ้มครองข้อมูลส่วนบุคคล
            </a>
          </label>

          <div className={styles.button}>
            <Button onClick={submitData}>ยืนยันข้อมูล</Button>
          </div>
           <div className={styles.button}>
            <ButtonBack onClick={props.navigatePrevPage}>ย้อนกลับ</ButtonBack>
          </div>
        </form>
      )}
    </div>
  );
}

export default Suggestions;
